import { useTranslation } from "react-i18next";
import { Warning } from "@phosphor-icons/react";

export const Wall = () => {
  const { t } = useTranslation();
  const items = t("gestion.wall.items", { returnObjects: true });

  return (
    <section
      data-testid="gestion-wall"
      className="py-24 md:py-32 bg-slate-50 border-y border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <p className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            {t("gestion.wall.kicker")}
          </p>
          <h2 className="mt-4 font-heading text-4xl md:text-5xl font-bold tracking-tight text-slate-900 leading-[1.05]">
            {t("gestion.wall.title")}
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-slate-600">
            {t("gestion.wall.lead")}
          </p>
        </div>

        <div className="mt-16 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, i) => (
            <article
              key={i}
              data-testid={`wall-item-${i}`}
              className="rounded-2xl border border-slate-200 bg-white p-6 flex flex-col"
            >
              <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-amber-50 border border-amber-100">
                <Warning
                  size={18}
                  weight="bold"
                  className="text-amber-600"
                />
              </div>
              <h3 className="mt-6 font-heading text-base md:text-lg font-bold tracking-tight text-slate-900">
                {it.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-slate-600">
                {it.desc}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Wall;
